module.exports = __webpack_public_path__ + "img/s-skills.aabd8ad9.svg";